import {
	CLEAR_REFRESH_LINKEDIN_PROFILE_SCRAPE_INFO,
	CURRENT_REFRESH_LINKEDIN_PROFILE_SCRAPE_INFO,
	REFRESH_LINKEDIN_PROFILE_IN_PROGRESS,
	UPDATE_CANDIDATE_PROFILE_AFTER_REFRESH,
} from "store/mapXActionTypes";
import {SICandidate, TCandidateImportRequestResponse} from "api/candidateApi/types";

export function refreshLinkedInCandidateInProgress(payload: {[x: string]: boolean}) {
	return {type: REFRESH_LINKEDIN_PROFILE_IN_PROGRESS, payload};
}

export function setCurrentRefreshLinkedInProfileScrapeInfo(payload: {
	[x: string]: TCandidateImportRequestResponse;
}) {
	return {type: CURRENT_REFRESH_LINKEDIN_PROFILE_SCRAPE_INFO, payload};
}

export function clearRefreshLinkedInProfileScrapeInfo(payload: string) {
	return {type: CLEAR_REFRESH_LINKEDIN_PROFILE_SCRAPE_INFO, payload};
}

export function updateCandidateProfileAfterRefresh(payload: SICandidate) {
	return {type: UPDATE_CANDIDATE_PROFILE_AFTER_REFRESH, payload};
}
